// @ts-nocheck
export enum CrmRelationType {
  Task = 1,
  Project = 2,
  CrmRelation = 3,
}
